// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-25WsV","title":"title-12DV2","content":"content-37Aht","inner":"inner-2Q52c","icon":"icon-BYyi6","link":"link-1heyW"};